<template>
  <div class="care">
    <div class="row">
      <div class="col-12 col-sm-8 text-center text-sm-start">
        <span class="d-none d-sm-block">
          <page-title v-if="selectedChild" :title="'Verzorging ' + selectedChild.full_name" icon="care"></page-title>
          <page-title v-else :title="'Verzorging'" icon="care"></page-title>
        </span>
        <span class="d-block d-sm-none">
          <page-title :title="'Verzorging'" icon="care"></page-title>
        </span>
      </div>
      <div class="col-12 col-sm-4 text-end" style="padding-top: 8px; padding-bottom: 8px">
        <button v-if="isAuthorized('instructions', 'index', 'add')" v-on:click="showModal = true" class="d-block d-sm-none btn btn-success">
          Nieuw
        </button>
        <button v-if="isAuthorized('instructions', 'index', 'add')" v-on:click="showModal = true" class="d-none d-sm-block btn btn-success float-end">
          Nieuw
        </button>
      </div>
    </div>
    <span class="d-block d-sm-none" style="padding-top: 12px;"></span>
    <div class="row">
      <div class="col-12 col-sm-3" style="">
        <child-list class="d-none d-sm-block"></child-list>
        <child-list-select class="d-block d-sm-none"></child-list-select>
      </div>
      <div class="col-12 col-sm-9" style="padding-left: 0">
        <div style="background: white; height: 100%; padding-top: 20px;">
          <div v-if="!selectedChild">
            <p class="text-center" style="margin: 50px">
              Selecteer een kind
            </p>
          </div>
          <div v-if="selectedChild && isLoading === true">
            <p class="text-center" style="margin: 50px">
              Laden...
            </p>
          </div>
          <div v-else-if="selectedChild && instructions && instructions.length < 1">
            <p class="text-center" style="margin: 50px">
              Geen verzorging
            </p>
          </div>
          <div v-else-if="selectedChild && instructions && instructions.length > 0" v-bind:key="instruction.id"
               v-for="instruction in instructions" class="row mx-0" style="margin-bottom: 20px">
            <div class="col-sm-auto text-center">
              <icon v-if="instruction.priority === 1" name="care-prio-high"></icon>
              <icon v-else name="care-prio-normal"></icon>
            </div>
            <div class="col-sm-10">
              <p>
                <b>
                  {{ instruction.title }}
                </b>
                <br>
                <span v-if="instruction.modified_at" class="text-muted fst-italic">
                    Laatst bewerkt op {{ this.$moment(instruction.modified_at).format('dddd D MMMM YYYY') }}
                  </span>
                <span v-else class="text-muted fst-italic">
                    Aangemaakt op {{ this.$moment(instruction.created_at).format('dddd D MMMM YYYY') }}
                  </span>
                <br>
                <br>
                <span style="white-space: pre-line">
                {{ instruction.body }}
              </span>
              </p>
            </div>
            <div class="col-sm-12 text-end">
                <span v-if="isAuthorized('instructions', 'index', 'edit')" v-on:click="editInstruction(instruction)">
                  <icon class="me-2" name="edit"></icon>
                </span>
              <span v-if="isAuthorized('instructions', 'index', 'delete')" v-on:click="deleteInstruction(instruction)">
                  <icon name="delete"></icon>
                </span>
            </div>
            <div class="col-sm-12">
              <hr>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal v-if="showModal">
      <template v-slot:header>
        <h3 class="modal-title">
          Instructie
          <span v-if="selectedChild">
            {{ selectedChild.full_name }}
          </span>
        </h3>
      </template>
      <template v-slot:body>
        <div style="padding: 20px">
          <div v-if="saveError" class="alert alert-danger">Alle velden dienen gevuld te worden.</div>
          <label>Titel</label>
          <input required v-model="title" type="text" class="form-control" placeholder="Titel">
          <label>Omschrijving</label>
          <textarea-plus
              :value="description" @onChange="setDescription($event)"
              placeholder="Omschrijving..."
          ></textarea-plus>
          <label>Risico indicatie</label>
          <select v-model="priority" class="form-control">
            <option :value="0">Normaal</option>
            <option :value="1">Belangrijk</option>
          </select>
        </div>
      </template>
      <template v-slot:footer>
        <div>
          <button type="button" class="btn btn-outline-info me-2" v-on:click="showModal = false">Annuleren</button>
          <button type="button" class="btn btn-info" v-on:click="saveInstruction">Opslaan</button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
    import PageTitle from '@/components/Page-Title'
    import ChildList from '@/components/Child-List'
    import ChildListSelect from '@/components/Child-List-Select'
    import Icon from '@/components/Icon'
    import Modal from '@/components/Modal'
    import TextareaPlus from '@/components/Textarea-Plus'

    export default {
        name: 'care',
        components: {
            PageTitle,
            ChildList,
            ChildListSelect,
            Icon,
            Modal,
            TextareaPlus
        },
        data() {
            return {
                isLoading: false,
                instructions: null,
                showModal: false,
                id: null,
                child_id: null,
                title: null,
                description: null,
                priority: 0,
                saveError: false
            }
        },
        watch: {
            selectedChild(child) {
                this.selectChild(child)
            },
            showModal(bool) {
                if (bool === false) {
                    this.id = null
                    this.title = null
                    this.description = null
                    this.priority = 0
                }
            }
        },
        created() {
            this.selectChild(this.selectedChild)
            this.$store.dispatch('getChildren')
        },
        methods: {
            setDescription(text) {
                this.description = text
            },
            selectChild(child) {
                if (!child) {
                  return
                }

                this.child_id = child.id
                this.isLoading = true
                this.instructions = null
                this.$request.get('/instructions?id_child=' + child.id)
                .then((response) => {
                  this.isLoading = false
                  this.instructions = response.data
                })
            },
            saveInstruction() {
                var idChild = this.child_id
                if (this.id) {
                    if (this.title && this.description) {
                      this.isLoading = true
                      this.$request.put('/instructions/' + this.id, {
                        title: this.title,
                        body: this.description,
                        priority: this.priority
                      }).then(() => {
                          this.saveError = false
                          this.showModal = false
                          this.isLoading = false
                          this.selectChild(this.getChild(idChild))
                          this.$store.dispatch('getGroupInstructions')
                      })
                  } else {
                      this.saveError = true
                  }
                } else {
                  if (this.title && this.description) {
                      this.isLoading = true
                      this.$request.post('/instructions', {
                        child_id: this.child_id,
                        title: this.title,
                        body: this.description,
                        priority: this.priority
                      }).then(() => {
                          this.saveError = false
                          this.showModal = false
                          this.isLoading = false
                          this.selectChild(this.getChild(idChild))
                          this.$store.dispatch('getGroupInstructions')
                      })
                  } else {
                      this.saveError = true
                  }
                }
            },
            deleteInstruction(instruction) {
                if (confirm('Weet je zeker dat je deze instructie wilt verwijderen?') !== true) {
                    return
                }
                var idChild = this.child_id
                this.isLoading = true
                this.$request.delete('/instructions/' + instruction.id)
                .then(() => {
                    this.showModal = false
                    this.isLoading = false
                    this.selectChild(this.getChild(idChild))
                })
            },
            editInstruction(instruction) {
                this.id = instruction.id
                this.title = instruction.title
                this.description = instruction.body
                this.priority = instruction.priority
                this.showModal = true
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
